type PdfAsset = {
  type: string;
  meta: Record<string, unknown>;
};

/** A page preview swap within one PDF keeps the scale saved for that page. */
export function isPdfPageSwap(
  previous: PdfAsset | null | undefined,
  next: PdfAsset | null | undefined,
  cropChanged: boolean,
): boolean {
  if (cropChanged || previous?.type !== "image" || next?.type !== "image")
    return false;
  const source = previous.meta.documentSource;
  const previousPage = Number(previous.meta.pdfPage);
  const nextPage = Number(next.meta.pdfPage);
  return (
    typeof source === "string" &&
    source.length > 0 &&
    source === next.meta.documentSource &&
    Number.isInteger(previousPage) &&
    previousPage > 0 &&
    Number.isInteger(nextPage) &&
    nextPage > 0 &&
    previousPage !== nextPage
  );
}
